import { render, staticRenderFns } from "./TeamMembersManagement.vue?vue&type=template&id=128905fe&scoped=true"
import script from "./TeamMembersManagement.vue?vue&type=script&lang=ts"
export * from "./TeamMembersManagement.vue?vue&type=script&lang=ts"
import style0 from "./TeamMembersManagement.vue?vue&type=style&index=0&id=128905fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128905fe",
  null
  
)

export default component.exports